import React from "react";
import { useContent } from "@/contexts/ContentContext";

export const About = () => {
    const { content } = useContent();
    const a = content.about;
    return (
        <section id="about" data-testid="about-section" className="bg-white py-24 lg:py-28">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
                    <div className="lg:col-span-5">
                        <p className="label-eyebrow">{a.eyebrow}</p>
                        <h2 data-testid="about-title" className="mt-4 font-display font-semibold text-slate-900 text-3xl sm:text-4xl lg:text-[42px] leading-[1.1] tracking-tight">{a.title}</h2>
                    </div>
                    <div className="lg:col-span-7">
                        <div className="space-y-6 text-[15.5px] text-slate-600 font-body leading-relaxed">
                            <p>{a.paragraph_1}</p>
                            <p>{a.paragraph_2}</p>
                            {a.background_note && (
                                <div className="border-t border-slate-200 pt-6 mt-2">
                                    <p className="text-[13.5px] text-slate-500 leading-relaxed">{a.background_note}</p>
                                </div>
                            )}
                        </div>
                        <div className="mt-10 grid sm:grid-cols-3 gap-6">
                            {[
                                { v: "Diagnostic", l: "Structured assessments" },
                                { v: "Advisory", l: "Practical guidance" },
                                { v: "Knowledge", l: "Books & toolkits" },
                            ].map((it) => (
                                <div key={it.v} className="border-t-2 border-teal-600 pt-4">
                                    <p className="font-display text-lg font-semibold text-slate-900">{it.v}</p>
                                    <p className="mt-1 text-[13px] text-slate-500">{it.l}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
